module.exports = __webpack_public_path__ + "img/dartmouth.65eaef34.png";